import { Component, computed, input } from '@angular/core';
import type { OnyxOptional } from '@onyx/angular';
import type { Subject } from 'rxjs';
import { ModalRealizedByComponent } from '../../../../../common/components/modal-realized-by/modal-realized-by.component';
import { OrderMissingAssignmentType } from '../../../common/enums/order-missing-assignment-type';
import type { OrderPlanningMode } from '../../../common/enums/order-planning-mode';
import { OrderHelper } from '../../../common/helpers/order.helper';
import type { Order } from '../../../common/interfaces/order';
import { OrderModalAssignmentComponent } from './order-modal-assignment/order-modal-assignment.component';
import { OrderModalCancellationComponent } from './order-modal-cancellation/order-modal-cancellation.component';
import { OrderModalFinishedSectionComponent } from './order-modal-finished-section/order-modal-finished-section.component';
import { OrderModalOutsourcingDataComponent } from './order-modal-outsourcing-data/order-modal-outsourcing-data.component';
import { OrderModalPlanComponent } from './order-modal-plan/order-modal-plan.component';
import { OrderModalPlannedSwapPointComponent } from './order-modal-planned-swap-point/order-modal-planned-swap-point.component';
import { OrderModalRealizationComponent } from './order-modal-realization/order-modal-realization.component';
import { OrderModalRouteSummaryComponent } from './order-modal-route-summary/order-modal-route-summary.component';
import { OrderModalGoodsComponent } from './order-modal-summary-main-section/order-modal-goods/order-modal-goods.component';
import { OrderModalSummaryMainSectionComponent } from './order-modal-summary-main-section/order-modal-summary-main-section.component';

@Component({
  selector: 'app-order-modal-summary',
  imports: [
    OrderModalRouteSummaryComponent,
    OrderModalPlanComponent,
    OrderModalOutsourcingDataComponent,
    OrderModalSummaryMainSectionComponent,
    OrderModalFinishedSectionComponent,
    OrderModalGoodsComponent,
    OrderModalAssignmentComponent,
    ModalRealizedByComponent,
    OrderModalRealizationComponent,
    OrderModalCancellationComponent,
    OrderModalPlannedSwapPointComponent,
  ],
  templateUrl: './order-modal-summary.component.html',
  styleUrl: './order-modal-summary.component.scss',
})
export class OrderModalSummaryComponent {
  public readonly order = input.required<Order>();
  public readonly close$ = input.required<Subject<void>>();
  public readonly isInactive = input.required<boolean>();
  public readonly mode = input.required<OnyxOptional<OrderPlanningMode>>();

  protected readonly OrderHelper = OrderHelper;

  protected currentPoint = computed(() =>
    OrderHelper.getCurrentPoint(this.order().points),
  );
  protected missingAssignment = computed(() =>
    OrderHelper.getMissingAssignment(this.order()),
  );
  protected showMainSummarySection = computed(() => {
    const order = this.order();
    const missingAssignment = this.missingAssignment();

    if (OrderHelper.hasApprovedVehicle(order)) return false;
    if (!missingAssignment) return true;

    return (
      !order.relatedFleetSwap &&
      missingAssignment.type !== OrderMissingAssignmentType.ORDER_WITHOUT_DRIVER
    );
  });
}
